import React, { useRef, useState } from 'react';
import { ExecutiveBioNavy, exportExecutiveBioPdf, ExecutiveBioData } from '@/components/ExecutiveBioNavy';
import sample from '@/testdata/sample-executive-bio.json';

// Dev/QA harness: renders the navy Executive Bio with the approved sample data
// so the port can be compared against the reference PDF pixel for pixel.
// Route: /bio-preview
const BioPreviewTest: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [fit, setFit] = useState<string>('measuring…');
  const data = { ...(sample as unknown as ExecutiveBioData), photoUrl: '/test-headshot.jpg' };

  return (
    <div style={{ background: '#e5e7eb', minHeight: '100vh', padding: 16 }}>
      <div style={{ marginBottom: 12, display: 'flex', gap: 12, alignItems: 'center' }}>
        <button
          style={{ padding: '6px 14px', background: '#244061', color: '#fff', borderRadius: 6 }}
          onClick={() => ref.current && exportExecutiveBioPdf(ref.current, data.name)}
        >
          Download PDF
        </button>
        <span data-testid="fit" style={{ fontSize: 13 }}>fit: {fit}</span>
      </div>
      <div ref={ref} style={{ width: 1275 }}>
        <ExecutiveBioNavy
          data={data}
          onFitResult={(r) => setFit(r.ok ? `ok at ${r.fontPx}px/${r.gapPx}px` : 'FAILED')}
        />
      </div>
    </div>
  );
};

export default BioPreviewTest;
